import { Navigate } from "react-router-dom"
import { HEAT_PUMP_LIST } from "settings/url"

export default function HomePage() {
	// redirect to heat pump list page
	return <Navigate to={`/${HEAT_PUMP_LIST}`} replace />
}
